module.exports = "/images/regel-2.jpg?2bca26e9a2939aa9cf5a6d45715ceee3";